import CreateOrganisation from './CreateOrganisation'
import enhance from './CreateOrganisation.enhancer'

export default enhance(CreateOrganisation)



// WEBPACK FOOTER //
// ./src/containers/organisation/CreateOrganisation/index.js